var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1229 17.3111C13.9687 17.3067 13.8167 17.2735 13.6747 17.213C13.5348 17.1459 13.407 17.056 13.2966 16.9469L8.64684 12.2972C8.4329 12.0753 8.31335 11.7791 8.31335 11.4709C8.31335 11.1627 8.4329 10.8665 8.64684 10.6446L13.2966 5.99482C13.5217 5.79803 13.8099 5.68867 14.1089 5.68671C14.2576 5.68695 14.4048 5.7168 14.5418 5.77451C14.6789 5.83222 14.8031 5.91663 14.9072 6.02283C15.1446 6.22929 15.2906 6.52134 15.3134 6.83514C15.3114 7.1341 15.202 7.42239 15.0052 7.64744L11.1118 11.4989L14.9352 15.3223C15.0442 15.4328 15.1342 15.5606 15.2013 15.7005C15.2635 15.8468 15.2968 16.0037 15.2993 16.1627C15.2998 16.316 15.2713 16.468 15.2153 16.6108C15.1606 16.7582 15.0748 16.8921 14.9636 17.0033C14.8524 17.1145 14.7185 17.2004 14.5711 17.2551C14.4264 17.3012 14.2745 17.3202 14.1229 17.3111Z",
    fill: "#28293D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.05dd7351c3a6a4e3f144be1491efb1a9.svg";
export { ForwardRef as ReactComponent };